import React, { useEffect, useState } from "react";
import { Row, Badge, Popover, Spin } from "antd";
import notification from "../../services/notification";
import { NotificationWrapper, NotifyWrapper } from "./styled";
import { Link } from "react-router-dom";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import { domain } from "../../utils/domainUrls";
import io from 'socket.io-client';
import { extractToken } from "../../utils/localStorage";

const bell = [
  <svg
    width="27"
    height="27"
    viewBox="0 0 20 20"
    fill="var(--primary-text-color)"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path d="M10 2C6.68632 2 4.00003 4.68629 4.00003 8V11.5858L3.29292 12.2929C3.00692 12.5789 2.92137 13.009 3.07615 13.3827C3.23093 13.7564 3.59557 14 4.00003 14H16C16.4045 14 16.7691 13.7564 16.9239 13.3827C17.0787 13.009 16.9931 12.5789 16.7071 12.2929L16 11.5858V8C16 4.68629 13.3137 2 10 2Z"></path>
    <path d="M10 18C8.34315 18 7 16.6569 7 15H13C13 16.6569 11.6569 18 10 18Z"></path>
  </svg>,
];
const NotificationContent = ({ data, nextFunction, isNotifyLoading }) => {

  return (
    <>
      <NotificationWrapper id="scrollableDiv">
        {data?.length ? (
          <InfiniteScroll
            dataLength={data?.length}
            next={() => nextFunction(5)}
            hasMore={true}
            // scrollThreshold={1}
            // scrollThreshold={0.4}
            // loader={<h4>Loading...</h4>}
            scrollableTarget={"scrollableDiv"}
          >
            {data?.map((item, index) => (
              <div
                key={index}
                className="item-card justify-content-start mt-3"
                style={{
                  backgroundColor: !item?.isRead
                    ? "var(--border-color)"
                    : undefined,
                }}
              >
                <div className="item-heading-container">
                  {/* {item?.icon && (
                    <div className="mt-auto">{iconList[item?.icon]}</div>
                  )} */}

                  <Link
                    // to={path().BASE + item?.redirectionUrl}
                    // onClick={}
                    className="item-para mt-1 mx-3"
                  >
                    {item?.message?.trim()}
                  </Link>
                </div>
                <div className="d-flex justify-content-end">
                  <span className="item-time">
                    {moment(item?.createdAt).fromNow()}
                  </span>
                </div>
              </div>
            ))}
          </InfiniteScroll>
        ) : (
          <span className="mid">There are no notifications</span>
        )}
      </NotificationWrapper>
      <div className="d-flex justify-content-center">
        {isNotifyLoading && <Spin />}{" "}
      </div>
    </>
  );
};

const Notification = () => {
  const [open, setOpen] = useState(false);
  const [isNotifyLoading, setIsNotifyLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ size: 5, currentPage: 1 });
  const [currentSize, setCurrentSize] = useState(0);
  const [notCount, setNotCount] = useState(0);
  const user = extractToken();


  useEffect(() => {
    const socket = io(domain);
    try {
      socket.on(user?.sub?.toString(), (payload) => {
        setNotCount(payload?.notificationCount);
      });
    } catch (err) {
    }
  }, []);
  

  const hasNext = (size) => {
    setCurrentSize(currentSize + size);
  };

  const getNotification = async () => {
    try {
      setIsNotifyLoading(true);
      const res = await notification.getNotification(
        pagination?.size + currentSize,
        1
      );
      setIsNotifyLoading(false);
      setData(res?.data?.results);
    //   console.log("aman:", res?.data?.results)
    } catch (error) {
      setIsNotifyLoading(false);
    }
  };

  const getNotificationCount = async (isRead = false) => {
    try {
      setIsNotifyLoading(true);
      const res = await notification.getNotificationCount(isRead);
      setNotCount(res?.data?.notificationCount);
      setIsNotifyLoading(false);
    } catch (error) {
      setIsNotifyLoading(false);
    }
  };

  const markAllAsRead = async () => {
    try {
      setIsNotifyLoading(true);
      const res = await notification.markAllAsRead();
      setIsNotifyLoading(false);
    } catch (error) {
      setIsNotifyLoading(false);
    }
  };

  useEffect(() => {
    getNotificationCount();
  }, []);

  useEffect(() => {
    getNotification();
  }, [currentSize]);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [open]);

  const handleOpen = () => {
    setOpen(!open);
    setTimeout(() => {
      getNotification();
      getNotificationCount();
    }, 500);
  };

  return (
    <NotifyWrapper style={{ marginTop: "6px" }}>
    <Badge onClick={() => markAllAsRead()} count={notCount} className="mid">
        <Popover
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          placement="bottomLeft"
          open={open}
          onOpenChange={handleOpen}
          content={
            <NotificationContent
              isNotifyLoading={isNotifyLoading}
              data={data}
              nextFunction={hasNext}
            />
          }
          key={"popover"}
          title={
            <span
              className="font-bold"
              style={{
                letterSpacing: "0.9px",
                color: "var(--primary-text-color)",
              }}
            >
              Notification
            </span>
          }
          trigger={"click"}
        >
          <a onClick={(e) => e.preventDefault()}>{bell}</a>
        </Popover>
      </Badge>
    </NotifyWrapper>
  );
};

export default Notification;
